module.exports = __webpack_public_path__ + "img/water-graph-model.85c202d8.png";